import { getApiEndpoint, API_BASE_URL } from '../../../../config/api';
import { openPdfInline } from '../../../shared/PdfViewer/PdfViewerHost';

/**
 * Fetch the latest record from test-history for an asset and open its
 * report/certificate. HydraJaws test reports are always PDFs, so they always
 * use the inline viewer regardless of URL extension.
 */
export async function openLatestTestReport({ propertyId, assetType, assetId, fallbackAsset, emptyMessage, onEmpty, title }) {
  const resolveUrl = (raw) => {
    if (!raw) return null;
    if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
    return `${API_BASE_URL}/${raw.replace(/^\//, '')}`;
  };

  const tryOpen = (raw) => {
    const url = resolveUrl(raw);
    if (!url) return false;
    openPdfInline(url, title || 'Test Report');
    return true;
  };

  if (propertyId && assetType && assetId) {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        getApiEndpoint(`/api/properties/${propertyId}/test-history/${assetType}/${assetId}`),
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.ok) {
        const data = await res.json();
        const records = data.records || [];
        const latest = records[0];
        if (latest && tryOpen(latest.test_report_url || latest.test_certificate_url)) return;
      }
    } catch (err) {
      console.error('Failed to load latest test history:', err);
    }
  }

  if (fallbackAsset) {
    const candidates = [
      fallbackAsset.test_report_url,
      fallbackAsset.testReportUrl,
      fallbackAsset.test_certificate_url,
      fallbackAsset.testCertificateUrl,
      fallbackAsset.certificateUrl,
      fallbackAsset.certificate_url,
    ];
    for (const c of candidates) {
      if (tryOpen(c)) return;
    }
  }

  if (onEmpty) onEmpty(emptyMessage || 'No test report available for this asset');
}
